import { SET_NUDATA_HAS_ERROR, SET_NUDATA_SESSION } from 'stash/actions/nudata';

const nudata = (state = {}, action) => {
  switch (action.type) {
    case SET_NUDATA_HAS_ERROR: {
      return {
        ...state,
        hasError: action.hasError,
      };
    }

    case SET_NUDATA_SESSION: {
      return {
        ...state,
        session: action.nudataSession,
      };
    }

    default:
      return state;
  }
};

export default nudata;
